import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ArrowForward } from '@material-ui/icons';
import { Typography, makeStyles } from '@material-ui/core';

import { Cards } from 'src/components';
import { AspectCategoryStatusIcon } from 'src/scenes/Project/scenes/PressuresAndDependencies/components';
import { aspectCategoryStatusPriority as concernLevelsArray, getConcernLevel } from 'src/utils/aspectCategoriesUtils';


const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
    minWidth: 150,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  cardBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

const getRandomConcernLevel = () => {
  const idx = Math.floor(Math.random() * concernLevelsArray.length);
  return concernLevelsArray[idx];
};

const ProjectsByConcernLevel = ({ projects = [], goToProject, concernLevels }) => {
  const classes = useStyles();
  const cardsRef = useRef();
  const [ projectsWithLevels, setProjectsWithLevels ] = useState([]);

  useEffect(() => {
    const sorted = projects.map(p => {
      const concernLevel = concernLevels ? getConcernLevel(concernLevels.find(cl => cl.id === p.id)?.value) : getRandomConcernLevel();
      return { ...p, concernLevel };
    }).sort((a, b) => concernLevelsArray.indexOf(a.concernLevel) - concernLevelsArray.indexOf(b.concernLevel));

    setProjectsWithLevels(sorted);
  }, [ projects, concernLevels ]);

  useEffect(() => {
    const cardPagination = cardsRef.current.getPagination();
    cardPagination.jump(0);
  }, [ projectsWithLevels ]);

  const cardActions = itemData => ([
    {
      Icon: ArrowForward,
      tooltip: 'Ver proyecto',
      onClick: () => goToProject(itemData),
    },
  ]);

  const columns = [
    {
      title: 'Nombre',
      minWidth: 150,
      render: itemData => (
        <Typography variant="body2" className={classes.title} color="textSecondary">{itemData.name}</Typography>
      ),
    },
    {
      title: 'Nivel de preocupación',
      minWidth: 90,
      render: itemData => (
        <AspectCategoryStatusIcon category={itemData.concernLevel} size="small" />
      ),

    },
  ];

  return (
    <Cards
      ref={cardsRef}
      columns={columns}
      values={projectsWithLevels}
      variant="condensed"
      actions={cardActions}
    />
  );
};

ProjectsByConcernLevel.propTypes = {
  projects: PropTypes.array,
  concernLevels: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    value: PropTypes.number,
  })),
  goToProject: PropTypes.func,
};


export { ProjectsByConcernLevel };

